/* ===================================================================
   Stand Popup – device + two bubbles, arrows switch grades
   =================================================================== */

(function () {
  'use strict';

  if (window.__standPopupLoaded) return;
  window.__standPopupLoaded = true;

  let rootEl = null;
  let standsData = [];
  let allStandsData = [];
  let currentStandIdx = 0;
  let swipeBound = false;
  let skipStandMotion = false;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const root = document.getElementById('stand-popup-root');
    if (!root) {
      if (!window.__standPopupInitTries) window.__standPopupInitTries = 0;
      if (window.__standPopupInitTries++ < 25) {
        setTimeout(init, 200);
      }
      return;
    }
    if (root.dataset.standPopupReady === '1') return;
    root.dataset.standPopupReady = '1';

    let stands = [];
    try { stands = JSON.parse(root.dataset.stands || '[]'); } catch(e) { return; }
    if (!stands.length) return;

    rootEl = root;
    allStandsData = stands;
    standsData = filterStandsForProduct(stands, root);

    setText('#cm-label', 'Stand');
    setText('#cm-notice', root.dataset.notice);

    buildTabs(standsData, root);

    root.querySelectorAll('[data-stand-close]').forEach(el => {
      el.addEventListener('click', () => closePopup(root));
    });
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape' && root.style.display !== 'none') closePopup(root);
      if (root.style.display === 'none') return;
      if (e.code === 'ArrowLeft' && currentStandIdx > 0) {
        showStand(standsData[currentStandIdx - 1], currentStandIdx - 1, root);
      }
      if (e.code === 'ArrowRight' && currentStandIdx < standsData.length - 1) {
        showStand(standsData[currentStandIdx + 1], currentStandIdx + 1, root);
      }
    });
    const chooseBtn = document.getElementById('cm-choose');
    if (chooseBtn) {
      chooseBtn.addEventListener('click', () => {
        if (chooseBtn.disabled || chooseBtn.classList.contains('is-disabled')) return;
        const stand = standsData[currentStandIdx];
        if (!stand || !isStandAvailable(stand.title)) return;
        const mode = getStandMode(root);
        if (mode === 'product') {
          // Already on this unique unit — confirm & close
          closePopup(root);
          return;
        }
        selectStandVariant(stand.title);
        closePopup(root);
      });
    }

    document.addEventListener('change', (e) => {
      const input = e.target.closest('input[type="radio"], select');
      if (!input) return;
      // Refresh availability when any variant option changes while popup is open
      if (root.style.display !== 'none') {
        refreshStandsFromProduct(root);
        const stand = standsData[currentStandIdx];
        if (stand) updateChooseButton(stand.title);
      }
      if (input.tagName === 'SELECT') return;
      const fieldset = input.closest('fieldset');
      if (!fieldset) return;
      const legend = fieldset.querySelector('.product-form__group-name, legend, label');
      if (!legend) return;
      if (!isStandLegendEl(legend)) return;
      const idx = standsData.findIndex(s => s.title.toLowerCase() === input.value.toLowerCase());
      if (idx !== -1) showStand(standsData[idx], idx, root);
    });

    injectReadMore(standsData, root.dataset.readMore || 'info', root);
  }

  function parseStandValues(root) {
    try {
      const raw = root.dataset.standValues || '[]';
      const vals = JSON.parse(raw);
      return Array.isArray(vals) ? vals.map(v => String(v).toLowerCase().trim()).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }


  function legendStandName(el) {
    if (!el) return '';
    const clone = el.cloneNode(true);
    clone.querySelectorAll('.stand-read-more, .stand-legend-row, button, a, script, style').forEach(function (n) {
      n.remove();
    });
    return clone.textContent.replace(/:/g, '').trim().toLowerCase();
  }

  function isStandLegendEl(el) {
    return legendStandName(el) === 'stand';
  }

  function isStandRadioName(name) {
    const n = String(name || '').toLowerCase().trim();
    return n === 'stand' || n.indexOf('stand-') === 0 || n.indexOf('stand ') === 0;
  }

  function getStandInputs() {
    const out = [];
    const radios = document.querySelectorAll('input[type="radio"]');
    for (let i = 0; i < radios.length; i++) {
      const input = radios[i];
      if (isStandRadioName(input.getAttribute('name'))) {
        out.push(input);
        continue;
      }
      const fieldset = input.closest('fieldset');
      if (!fieldset) continue;
      const legend = fieldset.querySelector('.product-form__group-name, legend, label.product-form__group-name');
      if (!legend) continue;
      if (!isStandLegendEl(legend)) continue;
      out.push(input);
    }
    return out;
  }

  function getStandSelect() {
    const selects = document.querySelectorAll('select');
    for (let i = 0; i < selects.length; i++) {
      const sel = selects[i];
      const label = (sel.getAttribute('name') || '') + ' ' + (sel.getAttribute('aria-label') || '');
      const nearby = sel.closest('.product-form__input, .product-form__group, fieldset');
      const legend = nearby && nearby.querySelector('.product-form__group-name, legend, label');
      const hay = (label + ' ' + (legend ? legend.textContent : '')).toLowerCase();
      if (hay.indexOf('stand') === -1) continue;
      return sel;
    }
    return null;
  }

  function existingStandTitlesFromDom() {
    const titles = [];
    getStandInputs().forEach(input => {
      const v = (input.value || '').trim();
      if (v) titles.push(v.toLowerCase());
    });
    const sel = getStandSelect();
    if (sel) {
      for (let j = 0; j < sel.options.length; j++) {
        const v = (sel.options[j].value || sel.options[j].text || '').trim();
        if (v) titles.push(v.toLowerCase());
      }
    }
    return titles;
  }

  function filterStandsForProduct(stands, root) {
    const mode = ((root.dataset.standMode || '')).toLowerCase();
    const hasOpt = (root.dataset.hasStandOption || '') === 'true';
    let allowed = parseStandValues(root);
    if (!allowed.length) {
      allowed = existingStandTitlesFromDom();
    }
    if (mode === 'product') {
      const cur = (root.dataset.currentStand || '').toLowerCase().trim();
      if (cur) allowed = [cur];
      // MacBooks: only the stand of THIS unit (other grades = other products)
      if (allowed.length) {
        return stands.filter(s => allowed.indexOf((s.title || '').toLowerCase().trim()) !== -1);
      }
      return stands.slice(0, 1);
    }
    if (!hasOpt && !allowed.length) return stands.slice();
    if (!allowed.length) return stands.slice();
    return stands.filter(s => allowed.indexOf((s.title || '').toLowerCase().trim()) !== -1);
  }

  function refreshStandsFromProduct(root) {
    const filtered = filterStandsForProduct(allStandsData.length ? allStandsData : standsData, root);
    const prevTitle = (standsData[currentStandIdx] && standsData[currentStandIdx].title) || '';
    standsData = filtered;
    buildTabs(standsData, root);
    let idx = standsData.findIndex(s => s.title.toLowerCase() === prevTitle.toLowerCase());
    if (idx < 0) idx = 0;
    if (standsData.length) showStand(standsData[idx], idx, root);
  }

  function getStandMode(root) {
    const r = root || rootEl;
    return ((r && r.dataset.standMode) || '').toLowerCase();
  }

  function getCurrentProductStand(root) {
    const r = root || rootEl;
    return ((r && r.dataset.currentStand) || '').toLowerCase().trim();
  }

  function isProductAvailable(root) {
    const r = root || rootEl;
    if (!r) return true;
    return (r.dataset.productAvailable || 'true') === 'true';
  }

  function isStandAvailable(title) {
    const want = (title || '').toLowerCase().trim();
    if (!want) return false;
    const mode = getStandMode();

    // MacBook / computer: one physical product, stand from metafield/title
    if (mode === 'product') {
      const cur = getCurrentProductStand();
      if (!cur) return false;
      if (want !== cur) return false; // other grades are other products → Udsolgt here
      return isProductAvailable();
    }

    const inputs = getStandInputs();
    if (inputs.length) {
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if ((input.value || '').toLowerCase().trim() !== want) continue;
        if (input.disabled) return false;
        if (input.classList.contains('disabled')) return false;
        const label = document.querySelector('label[for="' + input.id + '"]');
        if (label && label.classList.contains('disabled')) return false;
        return true;
      }
      return false;
    }
    const sel = getStandSelect();
    if (sel) {
      for (let j = 0; j < sel.options.length; j++) {
        const opt = sel.options[j];
        const val = (opt.value || opt.text || '').toLowerCase().trim();
        if (val !== want) continue;
        if (opt.disabled) return false;
        if (opt.classList && opt.classList.contains('disabled')) return false;
        return true;
      }
      return false;
    }
    return false;
  }

  function updateChooseButton(title) {
    const chooseBtn = document.getElementById('cm-choose');
    if (!chooseBtn) return;
    const labelChoose = chooseBtn.dataset.labelChoose || 'Vælg stand';
    const labelSold = chooseBtn.dataset.labelSoldout || 'Udsolgt';
    const ok = isStandAvailable(title);
    chooseBtn.disabled = !ok;
    chooseBtn.classList.toggle('is-disabled', !ok);
    chooseBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    chooseBtn.textContent = ok ? labelChoose : labelSold;
  }

  function buildTabs(stands, root) {
    const container = document.getElementById('cm-tabs');
    if (!container) return;
    container.innerHTML = '';

    stands.forEach((stand, i) => {
      if (!stand.title) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = stand.title;
      if (i === 0) btn.classList.add('active');
      btn.addEventListener('click', () => showStand(stand, i, root));
      container.appendChild(btn);
    });
  }

  function showStand(stand, idx, root) {
    const prevIdx = currentStandIdx;
    currentStandIdx = idx;
    document.querySelectorAll('#cm-tabs button').forEach((btn, i) => {
      btn.classList.toggle('active', i === idx);
      const s = standsData[i];
      if (s) btn.classList.toggle('is-unavailable', !isStandAvailable(s.title));
    });

    buildGallery(stand);

    setText('#cm-title', stand.title);
    setText('#cm-description', stand.description || '');

    updateBadges(stand, root);
    updateChooseButton(stand.title);
    if (skipStandMotion) {
      skipStandMotion = false;
    } else {
      playCarouselMotion(prevIdx, idx);
    }
    wireGradeNav(root);
  }

  function playCarouselMotion(fromIdx, toIdx) {
    if (fromIdx === toIdx) return;
    const wrap = document.getElementById('cm-gallery-wrap');
    const content = document.querySelector('#stand-popup-root .cm-content');
    const cls = toIdx > fromIdx ? 'cm-slide-next' : 'cm-slide-prev';
    [wrap, content].forEach(function (el) {
      if (!el) return;
      el.classList.remove('cm-slide-next', 'cm-slide-prev');
      void el.offsetWidth;
      el.classList.add(cls);
    });
  }

  function toSrc(url) {
    if (!url || url === '//' || url === 'https://' || url === 'https:///') return '';
    if (/^https?:\/\//i.test(url)) return url;
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function hideDots() {
    const dotsEl = document.getElementById('cm-dots');
    if (dotsEl) {
      dotsEl.innerHTML = '';
      dotsEl.hidden = true;
      dotsEl.style.display = 'none';
    }
  }

  function setOverlayStage(html) {
    const stage = document.getElementById('cm-special-stage');
    const gallery = document.getElementById('cm-gallery');
    if (stage) {
      stage.hidden = false;
      stage.innerHTML = html;
    }
    if (gallery) {
      gallery.innerHTML = '';
      gallery.style.display = 'none';
    }
    hideDots();
  }

  function imgTag(src, className, alt) {
    const safeAlt = (alt || '').replace(/"/g, '&quot;');
    return '<img class="' + className + '" src="' + src + '" alt="' + safeAlt + '" loading="eager">';
  }

  function buildGallery(stand) {
    const wrap = document.getElementById('cm-gallery-wrap');
    const device = toSrc(stand.device || stand.image);
    const b1 = toSrc(stand.bubble1);
    const b2 = toSrc(stand.bubble2);
    if (!device && !b1 && !b2) {
      if (wrap) wrap.style.display = 'none';
      return;
    }
    if (wrap) wrap.style.display = '';
    const title = stand.title || '';
    const bubblesOnly = !device && !!(b1 || b2);
    let html = '<div class="cm-overlay-stage' + (bubblesOnly ? ' is-bubbles-only' : '') + '">';
    if (device) html += imgTag(device, 'cm-device', title);
    if (b1) html += imgTag(b1, 'cm-bubble b1', title + ' – brugsspor');
    if (b2) html += imgTag(b2, 'cm-bubble b2', title + ' – hjørne');
    html += '</div>';
    setOverlayStage(html);
  }

  function wireGradeNav(root) {
    const prevBtn = document.getElementById('cm-prev');
    const nextBtn = document.getElementById('cm-next');
    const count = standsData.length;
    if (prevBtn) {
      prevBtn.hidden = count < 2 || currentStandIdx <= 0;
      prevBtn.onclick = function () {
        if (currentStandIdx > 0) {
          showStand(standsData[currentStandIdx - 1], currentStandIdx - 1, root);
        }
      };
    }
    if (nextBtn) {
      nextBtn.hidden = count < 2 || currentStandIdx >= count - 1;
      nextBtn.onclick = function () {
        if (currentStandIdx < count - 1) {
          showStand(standsData[currentStandIdx + 1], currentStandIdx + 1, root);
        }
      };
    }
    hideDots();
    bindGradeSwipe(root);
  }

  function bindGradeSwipe(root) {
    const wrap = document.getElementById('cm-gallery-wrap');
    if (!wrap || wrap.dataset.swipeBound === '1') return;
    wrap.dataset.swipeBound = '1';
    let startX = 0;
    let startY = 0;
    wrap.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (!e.changedTouches || !e.changedTouches[0]) return;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0 && currentStandIdx < standsData.length - 1) {
        showStand(standsData[currentStandIdx + 1], currentStandIdx + 1, root);
      } else if (dx > 0 && currentStandIdx > 0) {
        showStand(standsData[currentStandIdx - 1], currentStandIdx - 1, root);
      }
    }, { passive: true });
  }

  function selectStandVariant(title) {
    const want = (title || '').toLowerCase().trim();
    if (!want) return false;
    const radios = getStandInputs();
    for (let i = 0; i < radios.length; i++) {
      const input = radios[i];
      if ((input.value || '').toLowerCase().trim() !== want) continue;
      if (input.classList.contains('disabled') || input.disabled) return false;
      input.checked = true;
      try { input.click(); } catch (err) {}
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      // Nudge theme VariantRadios / VariantSelects if present
      const host = input.closest('variant-radios, variant-selects');
      if (host) {
        try { host.dispatchEvent(new Event('change', { bubbles: true })); } catch (err2) {}
      }
      return true;
    }
    // Fallback: option selects
    const selects = document.querySelectorAll('select');
    for (let i = 0; i < selects.length; i++) {
      const sel = selects[i];
      const label = (sel.getAttribute('name') || '') + ' ' + (sel.getAttribute('aria-label') || '');
      const nearby = sel.closest('.product-form__input, .product-form__group, fieldset');
      const legend = nearby && nearby.querySelector('.product-form__group-name, legend, label');
      const hay = (label + ' ' + (legend ? legend.textContent : '')).toLowerCase();
      if (hay.indexOf('stand') === -1) continue;
      for (let j = 0; j < sel.options.length; j++) {
        if ((sel.options[j].value || sel.options[j].text || '').toLowerCase().trim() === want) {
          sel.selectedIndex = j;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  function updateBadges(stand, root) {
    const footer = document.getElementById('cm-footer');
    if (!footer) return;
    footer.innerHTML = '';
    const battery = (stand.battery || '').trim();
    ['Gennemtestet', battery, '3 års garanti'].forEach(label => {
      if (!label) return;
      const div = document.createElement('div');
      div.className = 'condition-modal__badge';
      div.textContent = label;
      footer.appendChild(div);
    });
  }

  function openPopup(root, stands, currentStand) {
    if (root.parentElement !== document.body) document.body.appendChild(root);
    root.style.display = 'flex';

    // Re-filter against live product options / availability
    const source = allStandsData.length ? allStandsData : stands;
    standsData = filterStandsForProduct(source, root);
    buildTabs(standsData, root);
    stands = standsData;

    let idx = stands.findIndex(s =>
      s.title.toLowerCase() === (currentStand || '').toLowerCase()
    );
    if (idx < 0) idx = 0;

    if (!stands.length) {
      updateChooseButton('');
      return;
    }

    skipStandMotion = true;
    showStand(stands[idx], idx, root);

    const scrollY = window.scrollY;
    document.body.dataset.standScrollY = scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function closePopup(root) {
    root.style.display = 'none';
    const scrollY = parseInt(document.body.dataset.standScrollY || '0');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    delete document.body.dataset.standScrollY;
    window.scrollTo(0, scrollY);
  }

  function gradeFromTitle(title) {
    const t = (title || '').toLowerCase();
    const order = ['rigtig god', 'som ny', 'brugbar', 'brugt'];
    for (let i = 0; i < order.length; i++) {
      if (t.indexOf(order[i]) !== -1) return order[i];
    }
    return '';
  }

  function resolveCurrentStand(stands, root) {
    const mode = ((root.dataset.standMode || '')).toLowerCase();
    if (mode === 'product') {
      const cur = (root.dataset.currentStand || '').trim();
      if (cur && stands.some(s => s.title.toLowerCase() === cur.toLowerCase())) return cur;
    }
    const standInputs = getStandInputs();
    let radioVal = '';
    for (let i = 0; i < standInputs.length; i++) {
      if (standInputs[i].checked) {
        radioVal = standInputs[i].value || '';
        break;
      }
    }
    if (radioVal && stands.some(s => s.title.toLowerCase() === radioVal.toLowerCase())) {
      return radioVal;
    }
    const title = root.dataset.productTitle
      || document.querySelector('.product__title, h1.product__title, h1')?.textContent
      || '';
    const fromTitle = gradeFromTitle(title);
    if (fromTitle) {
      const match = stands.find(s => s.title.toLowerCase() === fromTitle);
      if (match) return match.title;
    }
    return stands[0]?.title || '';
  }

  function findSoloAnchor() {
    const title = document.querySelector('.product__info-container .product__title')
      || document.querySelector('h1.product__title')
      || document.querySelector('.product__title')
      || document.querySelector('.product__title__wrapper')
      || document.querySelector('.product__info-container h1');
    if (title) return title;

    const specs = document.querySelector('.mac-specs-grid');
    if (specs) return specs;

    const variant = document.querySelector('variant-radios, variant-selects, .product-form__controls, .product-form__input, .product-form__group');
    if (variant) return variant;

    const buy = document.querySelector('.product-form__buttons, product-form, .product-form');
    if (buy) return buy;

    return null;
  }

  function triggerLabel(text) {
    let t = (text || 'info').trim();
    if (/^hvilken stand\??$/i.test(t) || /^hvilken stand\? ?›$/i.test(t)) t = 'info';
    if (/^info$/i.test(t) || /[›?]$/.test(t)) return t;
    return t + ' ›';
  }

  function createStandTrigger(stands, readMoreText, root, extraClass) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = extraClass ? 'stand-read-more ' + extraClass : 'stand-read-more';
    btn.textContent = triggerLabel(readMoreText);
    btn.setAttribute('aria-label', 'Info om stand');
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-controls', 'stand-popup-root');
    btn.addEventListener('click', () => {
      openPopup(root, standsData.length ? standsData : stands, resolveCurrentStand(standsData.length ? standsData : stands, root));
    });
    return btn;
  }

  function placeNextToStandLabel(legend, btn) {
    const first = Array.from(legend.childNodes).find(
      (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim()
    );
    if (first) {
      const trimmed = first.textContent.replace(/\s+$/, '');
      first.textContent = /:\s*$/.test(trimmed) ? trimmed + ' ' : trimmed.replace(/\s*$/, ': ');
      first.after(btn);
      return;
    }
    if (!/:\s*$/.test((legend.textContent || '').trim())) {
      legend.appendChild(document.createTextNode(': '));
    }
    legend.appendChild(btn);
  }

  function injectReadMore(stands, readMoreText, root) {
    let attempts = 0;
    const tryInject = setInterval(() => {
      if (document.querySelector('.stand-read-more')) {
        clearInterval(tryInject);
        return;
      }

      const legends = document.querySelectorAll(
        '.product-form__group-name, .product-form__controls legend, legend'
      );
      let standLegend = null;
      legends.forEach(el => {
        if (isStandLegendEl(el)) {
          standLegend = el;
        }
      });

      if (standLegend) {
        placeNextToStandLabel(standLegend, createStandTrigger(stands, readMoreText, root));
        clearInterval(tryInject);
        return;
      }

      // Give a Stand legend a short head start before falling back (phones).
      if (attempts < 2) {
        attempts += 1;
        return;
      }

      const anchor = findSoloAnchor();
      if (anchor) {
        const row = document.createElement('p');
        row.className = 'stand-read-more-row';
        const label = document.createElement('span');
        label.className = 'stand-read-more-label';
        label.textContent = 'Stand:';
        row.appendChild(label);
        row.appendChild(createStandTrigger(stands, readMoreText, root, 'stand-read-more--solo'));
        anchor.insertAdjacentElement('afterend', row);
        clearInterval(tryInject);
        return;
      }

      if (++attempts > 30) clearInterval(tryInject);
    }, 200);
  }

  window.addEventListener('pagehide', () => {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.overflow = '';
  });

  function setText(selector, text) {
    const el = document.querySelector(selector);
    if (el && text !== undefined) el.textContent = text;
  }

})();
